import React from 'react';
import { Row } from 'react-bootstrap';
import Category from '../components/Category';

import '../css/projects.css';

import actingReel from '../img/acting-reel/jamie-sparker-acting-reel.jpg';
import auditionTapes from '../img/audition-tapes/jamie-sparker-audition-tapes.png';
import films from '../img/jamie-sparker-films.jpeg';
import musicVideos from '../img/music-videos/jamie-sparker-music-videos.png';
import modeling from '../img/modeling/jamie-sparker-modeling.jpg';

function Projects(props) {
  return (
    <section
      className={`${props.openMenu ? 'display-none' : ''}`}
      id='projects'
    >
      <Row className='projects-row'>
        <Category
          photo={actingReel}
          title={`Acting Reel`}
          overlay={'0.1'}
          route='acting-reel'
          routable={true}
          hover={true}
        />
        <Category
          photo={auditionTapes}
          title='Audition Tapes'
          overlay={'0.3'}
          route='audition-tapes'
          routable={true}
          hover={true}
        />
        <Category
          photo={musicVideos}
          title='Music Videos'
          overlay={'0.3'}
          route='music-videos'
          routable={true}
          hover={true}
        />
        <Category
          photo={modeling}
          title='Modeling'
          overlay={'0.4'}
          route='modeling'
          routable={true}
          hover={true}
        />
        <Category photo={films} title='Films (Coming Soon)' overlay={'0.8'} />
      </Row>
    </section>
  );
}

export default Projects;
